import React from 'react'

const LandingNavTop = () => {
  return (
    <div>

        <div className="landing-nav-top" >


          {/* <div>We do not offer Van Services.  </div>
          <span>Towel must be provided by customer.</span> */}
          
            {/* <div className='top-header-offter-text'>Navratri Special</div> */}
            <div> Get 15% Off On All Packages Now !</div>
            <span>(Limited Period Offer*)</span>
            
            
        </div>
        
    </div>
  )
}

export default LandingNavTop